export default "__VITE_ASSET__UCJt53fF__"